import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import { RestConfigBase, RestMessageAdapter, RestRequestType } from "../common.browser/Exports";
import { PropertyId } from "../sdk/Exports";
import { ConnectionFactoryBase } from "./ConnectionFactoryBase";
import { HeaderNames } from "./HeaderNames";
/**
 * Implements methods for speaker recognition classes, sending requests to endpoint
 * and parsing response into expected format
 * @class SynthesisRestAdapter
 */

export var SynthesisRestAdapter = /*#__PURE__*/function () {
  function SynthesisRestAdapter(config) {
    _classCallCheck(this, SynthesisRestAdapter);

    var endpoint = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Endpoint, undefined);

    if (!endpoint) {
      var region = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Region, "westus");
      var hostSuffix = ConnectionFactoryBase.getHostSuffix(region);
      endpoint = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Host, "https://".concat(region, ".tts.speech").concat(hostSuffix));
    }

    this.privUri = "".concat(endpoint, "/cognitiveservices/voices/list");
    var options = RestConfigBase.requestOptions;
    options.headers[RestConfigBase.configParams.subscriptionKey] = config.parameters.getProperty(PropertyId.SpeechServiceConnection_Key, undefined);
    this.privRestAdapter = new RestMessageAdapter(options);
  }
  /**
   * Sends list voices request to endpoint.
   * @function
   * @public
   * @param connectionId - guid for connectionId
   * @returns {Promise<IRestResponse>} rest response to status request
   */


  _createClass(SynthesisRestAdapter, [{
    key: "getVoicesList",
    value: function getVoicesList(connectionId) {
      this.privRestAdapter.setHeaders(HeaderNames.ConnectionId, connectionId);
      return this.privRestAdapter.request(RestRequestType.Get, this.privUri);
    }
  }]);

  return SynthesisRestAdapter;
}();